<script lang="ts" setup>
defineOptions({
  name: 'CarouselControl',
});
</script>

<template>
  <div
    class="embla__control"
    data-scope="carousel"
    data-part="control"
  >
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
</style>
